import ky from 'ky';
import { API_URL } from '../../../shared/constants';
import { useAuthStore } from '../store/use-auth-store';

const publicApi = ky.create({
  prefixUrl: API_URL,
});

const authApi = ky.create({
  prefixUrl: API_URL,
  hooks: {
    beforeRequest: [
      (request, options, { retryCount }) => {
        // Only set default auth header on initial request, not on retries
        // (retries may have refreshed token set by beforeRetry)
        if (retryCount === 0) {
          const { jwt } = useAuthStore.getState();
          if (jwt) {
            request.headers.set('Authorization', `Bearer ${jwt}`);
          }
        }
      },
    ],
  },
});

export const api = {
  public: publicApi,
  auth: authApi,
};
